export enum AlertStatus {
  UNKNOWN_ALERT_STATUS = 'UNKNOWN_ALERT_STATUS',
  ALERT = 'ALERT',
  RESOLVED = 'RESOLVED'
}
